import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import Left from 'react-icons/lib/fa/angle-left';
import Right from 'react-icons/lib/fa/angle-right';
import { media } from 'lib/style-utils';
import { Link } from 'react-router-dom';

class MainCarousel extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  prev = () => {
    this.swiper.slidePrev();
  }

  next = () => {
    this.swiper.slideNext();
  }

  handleScrollTop = (e) => {
    window.scrollTo(0,0);
  }

  render() {
    const { prev, next, handleScrollTop } = this;
    const { color, homeData } = this.props;

    const Wrapper = styled.div`
      position: relative;
      width: 100%;
      height: calc(100vh - 76px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: ${props => props.color};
      overflow: hidden;
      transition: all .5s;

      ${media.tablet`
        height: 1100px;
      `}
      ${media.mobile`
        height: 560px;
      `}${media.iphone67p`
        height: 630px;
      `}
      ${media.iphone67`
        height: 561px;
      `}
    `;

    const SwiperWrapper = styled.div`
      width: 100%;
      position: relative;
      overflow: hidden;

      .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
        top: auto;
        bottom: 50px !important;
      }
    `;

const Btn = styled.div`
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 70px;
      color: #fff;
      line-height: 50px;
      padding-bottom: 5px;
      cursor: pointer;
      z-index: 15;

      ${media.mobile`
        font-size: 40px;
        top: 279px;
        transform: translateY(0);
      `}
      ${media.iphone67p`
        top: 313px;
      `}
      ${media.iphone67`
        top: 279px;
      `}
    `;

    const BtnBackground = styled.div`
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background: #999;
      opacity: 0.3;
      z-index: 10;

      ${media.mobile`
        display: none;
        width: 50px;
        height: 50px;
        top: 285px;
        transform: translateY(0);
      `}
    `;

    const BtnLeftBackground = BtnBackground.extend`
      left: 50px;

      ${media.mobile`
        left: 20px;
      `}
    `;

    const BtnRightBackground = BtnBackground.extend`
      right: 50px;

      ${media.mobile`
        right: 20px;
      `}
    `;

    const BtnLeft = Btn.extend`
      left: 58px;

      ${media.mobile`
        display: none;
        left: 24px;
      `}
    `;

    const BtnRight = Btn.extend`
      right: 58px;

      ${media.mobile`
        display: none;
        right: 24px;
      `}
    `;

    const Title = styled.div`
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 1.9px;
      color: #333333;
      z-index: 10;

      ${media.mobile`
        top: 50px;
        font-size: 20px;
      `}
    `;

    const PicWrapper = styled.div`
      width: 3000px;
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      text-align: center;
      transition: all .5s;

      ${media.w1440`
        width: 100%;
      `}
      ${media.tablet`
        padding: 10px;
        top: 25%;
      `}
      ${media.w800`
        top: 25%;
      `}
      ${media.w800`
        top: 25%;
      `}
    `;

    const ColorText = styled.div`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.3px;
    `;

    const Img = styled.img`
      width: 400px;
      height: 400px;
      border-radius: 50%;

      ${media.w1440`
        width: 25%;
        height: 25%;
      `}
      ${media.tablet`
        width: 40%;
        height: 40%;
      `}
      ${media.mobile`
        width: 45%;
        height: 45%;
      `}
    `;

    const Number = styled.div`
      position: absolute;
      top: 180px;
      left: 50%;
      transform: translateX(-50%);
      width: 36px;
      padding: 10px;
      margin: 0 auto;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      background: #555555;
      border-radius: 50%;
      transition: all .5s;

      ${media.w1440`
        top: 150px;
      `}
      ${media.mobile`
        top: 85px;
        width: 26px;
        height: 26px;
        padding: 5px;
      `}
    `;

    const Collection = styled.div`
      position: absolute;
      width: 100%;
      text-align: center;
      top: 240px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.3px;
      color: #333333;
      transition: all .5s;

      ${media.w1440`
        top: 200px;
      `}
      ${media.mobile`
        top: 120px;
        font-size: 13px;
      `}
      ${media.se`
        font-size: 12px;
      `}
    `;

    const SeasonDesc = ColorText.extend`
      width: 100%;
      padding: 0 10px;
      text-align: center;
      font-family: 'Noto Sans KR', sans-serif;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.7;
      color: #333333;

      .mobile.hidden {
        display: block;
      }
      .mobile.show {
        display: none;
      }
      ${media.w800`
        font-size: 16px;
      `}
      ${media.mobile`
        .mobile.hidden {
          display: none;
        }
        .mobile.show {
          display: block;
        }
      `}
      ${media.se`
        font-size: 13px;
      `}
    `;

    const Viewmore = styled.button`
      width: 156px;
      height: 45px;
      margin-top: 40px;
      background: #fff;
      color: #999999;
      border: 1px solid #eeeeee;
      border-radius: 25px;
      font-family: Lato;
      font-size: 15px;
      line-height: 1;
      letter-spacing: 1.2px;
      cursor: pointer;

      &:hover {
        background: #f9f9f9;
      }

      &:active {
        background: #f2f2f2;
      }

      ${media.mobile`
        font-size: 13px;
      `}
    `;

    const params = {
      pagination: '.swiper-pagination',
      paginationClickable: true,
      spaceBetween: 0,
      speed: window.innerWidth > window.innerHeight ? 1000 : 500,
      loop: true,
      autoplay: 3000,
      autoplayDisableOnInteraction: true,
      onInit: (swiper) => {
        this.swiper = swiper
      }
    };

    const Desc = homeData.bottomCarouselDescription && homeData.bottomCarouselDescription.split('\n').map((paragraph, i) => {
      return (
        <p key={i}>{paragraph}</p>
      )
    });

    const DescMobile = homeData.bottomCarouselDescription_M && homeData.bottomCarouselDescription_M.split('\n').map((paragraph, i) => {
      return (
        <p key={i}>{paragraph}</p>
      )
    });

    return (
      <SwiperWrapper>
        <Title>{homeData.bottomCarouselTitle}</Title>
        <Swiper {...params}>
          <Wrapper color={color}>
            <Number>1</Number>
            <Collection>{homeData.bottomCarouselText1}</Collection>
            <PicWrapper>
              <Img src={homeData.bottomCarouselImages1_1 && homeData.bottomCarouselImages1_1.url} alt=""/>
              <Img src={homeData.bottomCarouselImages1_2 && homeData.bottomCarouselImages1_2.url} alt=""/>
              <Img src={homeData.bottomCarouselImages1_3 && homeData.bottomCarouselImages1_3.url} alt=""/>
              <Img src={homeData.bottomCarouselImages1_4 && homeData.bottomCarouselImages1_4.url} alt=""/>
            </PicWrapper>
          </Wrapper>

          <Wrapper color={color}>
            <Number>2</Number>
            <Collection>{homeData.bottomCarouselText1}</Collection>
            <PicWrapper>
              <Img src={homeData.bottomCarouselImages2_1 && homeData.bottomCarouselImages2_1.url} alt=""/>
              <Img src={homeData.bottomCarouselImages2_2 && homeData.bottomCarouselImages2_2.url} alt=""/>
              <Img src={homeData.bottomCarouselImages2_3 && homeData.bottomCarouselImages2_3.url} alt=""/>
              <Img src={homeData.bottomCarouselImages2_4 && homeData.bottomCarouselImages2_4.url} alt=""/>
            </PicWrapper>
          </Wrapper>

          <Wrapper color={color}>
            <SeasonDesc>
              <div className="mobile hidden">
                {Desc}
              </div>
              <div className="mobile show">
                {DescMobile}
              </div>
              <Link to="/lookbook" onClick={handleScrollTop}><Viewmore>VIEW MORE</Viewmore></Link>
            </SeasonDesc>
          </Wrapper>
        </Swiper>

        <BtnLeftBackground/>
        <BtnLeft><Left onClick={prev}/></BtnLeft>
        <BtnRightBackground/>
        <BtnRight><Right onClick={next}/></BtnRight>
      </SwiperWrapper>
    );
  }
}

export default MainCarousel;



// WEBPACK FOOTER //
// ./src/components/Home/SubCarousel.js